'use client';

export { default } from './ScopedCssBaseline';
export { default as scopedCssBaselineClasses } from './scopedCssBaselineClasses';
export * from './scopedCssBaselineClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/ScopedCssBaseline/index.js
// module id = 875
// module chunks = 22